import { motion } from "framer-motion";
import { socialTags } from "../data/socialTags";
import profilePhoto from "../assets/images/AshanMSilva.jpeg";
import SocialTag from "./SocialTag";

const Hero: React.FC = () => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center mt-8">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        className="md:col-span-2"
      >
        <p className="text-sm uppercase tracking-wide text-cyan-700">
          Hello, my name is
        </p>
        <h1 className="mt-2 text-5xl md:text-6xl font-extrabold text-cyan-700">
          Ashan Silva
        </h1>
        <p className="mt-4 text-lg text-gray-200 max-w-3xl">
          Software Engineer | Full-Stack Developer | Java | .NET | MEAN & MERN
          Stack | Web & Mobile Applications | Cloud & DevOps
        </p>

        <div className="mt-6 flex flex-wrap gap-3">
          {socialTags.map((s) => (
            <SocialTag socialLink={s} />
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="mx-auto md:mx-0"
      >
        <div className="w-44 h-44 rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/20">
          <img
            src={profilePhoto}
            alt="profile"
            className="w-full h-full object-cover"
          />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
